<template>
    <div class="body">
        <div class="box">
            <h1 class="has-text-centered title has-text-primary">Become Health Secure Today</h1>
            <b-button tag="a"
                      href="https://share.hsforms.com/1HFKFFJkKRTSZ_WTIhQVSFw4lq3k"
                      type="is-primary"
                      expanded
                      size="is-medium"
                      target="_blank">
                Download our Brochure
            </b-button>
        </div>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    export default {
        name: "DownloadBrochure",
        components: {BButton}
    }
</script>

<style scoped>
    .body {
        padding-left: 5%;
        padding-right: 5%;
        padding-top: 72px;
        padding-bottom: 72px;
    }

    .box {
        padding: 28px;
    }
</style>